import React, { useState } from 'react'
import './GroupDetails.css'
import Carousel from 'react-bootstrap/Carousel';
import { Popup } from "semantic-ui-react";
import { Link } from 'react-router-dom';
import DeletePostPopup from './DeletePostPopup';
import EditPostCommunity from './EditPostCommunity';



export default function GroupDetails() {
    const [comunityGroup, setComunityGroup] = useState({
        activeHeader: 'Post',
        showComment: false,
        requiestDeltail: 'UnderReview',
        deletePost: false,
        editPost:false
    })

    // for show more and hide text 
    const [showFullText, setShowFullText] = useState(false);
    const toggleShowFullText = () => {
        setShowFullText(!showFullText);
    };

    const text = "The expo begins with an account of account of science in ancient India and the country's  in the pre-Independence science in ancient India and the country's achievements in the pre-Independence period...";

    const trimmedText = showFullText ? text : text.slice(0, 110) + '...';
    const seeMoreLink = text.length > 100 ? (
        <span onClick={toggleShowFullText} className="see-more-link">
            {showFullText ? "Hide" : "See More"}
        </span>
    ) : null


    // below code for like and like 
    const formatLikeCount = (count) => {
        if (count >= 1000) {
            return (count / 1000).toFixed(1) + 'k';
        }
        return count;
    };

    const [isLiked, setIsLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(1200); // Start with 1.2k Likes

    const handleLikeClick = () => {
        if (isLiked) {
            setLikeCount(likeCount - 1);
        } else {
            setLikeCount(likeCount + 1);
        }
        setIsLiked(!isLiked);
    };
    // for edit the comment 
    const [editable, setEditable] = useState(false);
    const [nameTimeValue, setNameTimeValue] = useState(
        'Lorem Ipsum is simply dummy text of the printing and typesetting'
    );

    // Function to handle Edit button click
    const handleEditClick = () => {
        setEditable(!editable);
    };

    // Function to handle changes in the input field
    const handleInputChange = (e) => {
        setNameTimeValue(e.target.value);
    };


    // function to handle delete popup 
    const handleDeletePostPopUpFalse = (e) => {
        setComunityGroup({
            ...comunityGroup,
            deletePost: false
        })
    }
    
    // function to handle Edit post popup 
    const handleEditPostPopUpFalse = (e) => {
        setComunityGroup({
            ...comunityGroup,
            editPost: false
        })
    }
    return (
        <div className='TotalGroupsComunutyDetailContainer'>
            <div className='d-flex align-items-center gap-2'>
                <Link to='/EngagementCommunity'>
                    <div style={{ cursor: 'pointer' }}>
                        <img src='/Enggagement/BackArrow.png' alt='' />
                    </div>
                </Link>
                <div>
                    <img src='/Enggagement/GroupDetailProfileIcon.png' className='imgGroupIcons' alt='' />
                </div>
                <div>
                    <div className='groupName'>Xploresense Sports Corner Channel</div>
                    <div className='GroupNameDetail'>Created by Ms. Jasmine</div>
                </div>
            </div>
            <div className='d-flex justify-content-end '>
                <button className='postComunityBtnGroup'>Post to community</button>
            </div>
            <div className="five_component_Comunity ">
                <button className={comunityGroup.activeHeader === "Post" ? 'Four_btnActiveComunity' : "Four_btnComunity"} onClick={(e) => { setComunityGroup({ ...comunityGroup, activeHeader: 'Post' }) }} >
                    Posts (+120)
                </button>
                <button className={comunityGroup.activeHeader === "About" ? 'Four_btnActiveComunity' : "Four_btnComunity"} onClick={(e) => { setComunityGroup({ ...comunityGroup, activeHeader: 'About' }) }} >
                    About
                </button>
                <button className={comunityGroup.activeHeader === "Members" ? 'Four_btnActiveComunity' : "Four_btnComunity"} onClick={(e) => { setComunityGroup({ ...comunityGroup, activeHeader: 'Members' }) }} >
                    Members
                </button>
                <button className={comunityGroup.activeHeader === "MyRequests" ? 'Four_btnActiveComunity' : "Four_btnComunity"} onClick={(e) => { setComunityGroup({ ...comunityGroup, activeHeader: 'MyRequests' }) }} >
                    My Requests (2)
                </button>
            </div>


            <div className='row'>
                <div className='col-md-6'>
                    {/* below for post  */}
                    {comunityGroup.activeHeader === "Post" &&
                        <>
                            <div className='d-flex justify-content-between align-items-center mt-3'>
                                <div className='d-flex gap-2 '>
                                    <div>
                                        <img src='/Enggagement/ProifleCommunity.png' style={{ cursor: 'pointer' }} alt='' />
                                    </div>
                                    <div >

                                        <div className='d-flex align-items-center gap-1' >
                                            <div>
                                                <img src='/Enggagement/ProfileIcon.png' alt='' />
                                            </div>
                                            <div className='d-flex align-items-center gap-2'>
                                                <div className='ComunityName '>Jasmine Watson</div>
                                            </div>

                                        </div>
                                        <div className='NameTime'>
                                            Reading Club | Today 04:30 pm
                                        </div>
                                    </div>

                                    <div className='TopicCommunityBoxDetail '>Exhibition</div>

                                </div>


                                <Popup
                                    on="click"
                                    className="popUpFilter"
                                    trigger={
                                        <div >
                                            <img src='/Enggagement/ComunityThreeDots.png' style={{ cursor: 'pointer' }} alt='' />
                                        </div>
                                    }
                                    content={
                                        <div className='container_threedot p-3'>
                                            <div className='PopupThreedots p-1 d-flex align-items-center gap-3' >
                                                <div className='d-flex align-items-center'>
                                                    <img src='/Enggagement/EditeIconPoup.png' alt='' />
                                                </div>
                                                <div style={{ fontSize: '12px',cursor: 'pointer' }}>Edit</div>
                                            </div>
                                            <div className='PopupThreedots p-1 d-flex align-items-center gap-3'>
                                                <div className='d-flex align-items-center'>
                                                    <img src='/Enggagement/deleteIconPoup.png' alt='' />
                                                </div>
                                                <div style={{ fontSize: '12px',cursor: 'pointer' }} onClick={(e) => setComunityGroup({ ...comunityGroup, deletePost: true })}>Delete</div>
                                            </div>
                                        </div>
                                    }
                                    position="bottom center"
                                />
                            </div>
                            <p className='mt-2'>
                                <span className='captionText'>
                                    {trimmedText}
                                </span>
                                <span className='seeMoreText'>{seeMoreLink}</span>
                            </p>

                            <div className='sildeImgContainer'>
                                <Carousel>
                                    <Carousel.Item>
                                        <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                                    </Carousel.Item>
                                </Carousel>
                            </div>
                            <div className='d-flex justify-content-between mt-3'>

                                <span onClick={handleLikeClick}>
                                    {isLiked ? (
                                        <img src='/Enggagement/likedComuity.png' style={{ cursor: 'pointer' }} alt='' />
                                    ) : (
                                        <img src='/Enggagement/UnlikeComunity.png' style={{ cursor: 'pointer' }} alt='' />
                                    )}
                                    <span className='likesComment ml-1'>{formatLikeCount(likeCount)} Likes</span>
                                </span>

                                <span style={{ cursor: 'pointer' }} onClick={(e) => { setComunityGroup({ ...comunityGroup, showComment: true }) }}>
                                    <img src='/Enggagement/CommentIconComunity.png' alt='' />
                                    <span className='likesComment ml-1'>3.3K Comments</span>
                                </span>
                            </div>
                            {comunityGroup.showComment &&
                                <>
                                    <div className='mt-2 '>
                                        <div className='containerInputComment d-flex align-itmes-center'>
                                            <input placeholder='Write your comment' className='commentInput' />
                                            <div className='pt-1'>
                                                <img src='/Enggagement/SendImg.png' alt='' />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='mt-2'  >
                                        <span className='commentHeading1'>Comments </span><span className='commentHeading'>(2.2K)</span>
                                    </div>



                                    <div>
                                        <Popup
                                            on="click"
                                            className="popUpFilter"
                                            trigger={
                                                <div className='d-flex gap-2 align-itmes-center mt-3' >
                                                    <div>
                                                        <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                                    </div>
                                                    <div className='w-100' >
                                                        <div className='ChannelNameComunity'>
                                                            Can Berk Cilek
                                                            &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                                                        </div>
                                                        <div className='d-flex gap-3 '>
                                                            <div className='NameTime w-100'>
                                                                {editable ? (
                                                                    <textarea
                                                                        className='commentEditeInput'
                                                                        type='text'
                                                                        value={nameTimeValue}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                ) : (
                                                                    nameTimeValue
                                                                )}
                                                            </div>
                                                            {editable && <div className='d-flex gap-3'>
                                                                <div className='d-flex gap-2'
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={(e) => setEditable(false)}
                                                                >
                                                                    <div>
                                                                        <img style={{ cursor: 'pointer' }}

                                                                            src='/LibraryImg/EditDone.png' alt='replie icon' />
                                                                    </div>
                                                                    <span>Done</span>
                                                                </div>
                                                                <div className='d-flex gap-2'>
                                                                    <div>
                                                                        <img style={{ cursor: 'pointer' }}

                                                                            src='/LibraryImg/EditDiscard.png' alt='replie icon' />
                                                                    </div>
                                                                    <span>Discard</span>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            content={
                                                <div className='container_threedot p-3'>
                                                    <div className='PopupThreedots p-1 d-flex align-items-center gap-3' onClick={handleEditClick}>
                                                        <div className='d-flex align-items-center'>
                                                            <img src='/Enggagement/EditeIconPoup.png' alt='' />
                                                        </div>
                                                        <div style={{ fontSize: '12px' }}>Edit</div>
                                                    </div>
                                                    <div className='PopupThreedots p-1 d-flex align-items-center gap-3'>
                                                        <div className='d-flex align-items-center'>
                                                            <img src='/Enggagement/deleteIconPoup.png' alt='' />
                                                        </div>
                                                        <div style={{ fontSize: '12px' }}>Delete</div>
                                                    </div>
                                                </div>
                                            }
                                            position="bottom center"
                                        />

                                        <div className='d-flex gap-2 align-itmes-center mt-3' >
                                            <div>
                                                <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                            </div>
                                            <div >
                                                <div className='ChannelNameComunity'>
                                                    Can Berk Cilek
                                                    &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                                                </div>
                                                <div className='NameTime'>
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex gap-2 align-itmes-center mt-3' >
                                            <div>
                                                <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                            </div>
                                            <div >
                                                <div className='ChannelNameComunity'>
                                                    Can Berk Cilek
                                                    &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                                                </div>
                                                <div className='NameTime'>
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex gap-2 align-itmes-center mt-3' >
                                            <div>
                                                <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                            </div>
                                            <div >
                                                <div className='ChannelNameComunity'>
                                                    Can Berk Cilek
                                                    &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                                                </div>
                                                <div className='NameTime'>
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='viewMoreText mt-3'>View more comments</div>
                                </>}
                        </>}

                    {/* below of about  */}
                    {comunityGroup.activeHeader === 'About' &&
                        <div className='mt-3'>
                            <div className='channelsHeadingRight'>
                                Description
                            </div>
                            <div className='AboutDecriptions'>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            </div>
                            <div className='channelsHeadingRight mt-3'>
                                Created on
                            </div>
                            <div className='AboutDecriptions'>
                                20 June 2022
                            </div>
                            <div className='channelsHeadingRight mt-3'>
                                Created by
                            </div>
                            <div className='AboutDecriptions'>
                                Ms. Jasmine
                            </div>
                        </div>
                    }

                    {/* below code Of Memebers  */}
                    {comunityGroup.activeHeader === 'Members' &&
                        <div>
                            <div className='mt-3 d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center gap-3'>
                                    <div className='NameFirstLetter'>
                                        J
                                    </div>
                                    <div className='channelsHeadingRight'>Jasmine</div>
                                </div>
                                <div className='AdminMemeberText'>
                                    admin
                                </div>
                            </div>
                            <div className='mt-3 d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center gap-3'>
                                    <div className='NameFirstLetter'>
                                        X
                                    </div>
                                    <div className='channelsHeadingRight'>Xploresense Admin</div>
                                </div>
                                <div className='AdminMemeberText'>
                                    Moderator
                                </div>
                            </div>
                            <div className='mt-3 d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center gap-3'>
                                    <div className='NameFirstLetter'>
                                        9
                                    </div>
                                    <div className='channelsHeadingRight'>Class 9</div>
                                </div>
                                <div className='AdminMemeberText'>
                                    MEMBER
                                </div>
                            </div>

                        </div>
                    }

                    {/* below code Of Memebers  */}
                    {comunityGroup.activeHeader === 'MyRequests' &&
                        <div className=''>
                            {/* for no memeber  */}
                            {comunityGroup.requiestDeltail === 'NoRequest' &&
                                < div className='d-flex justify-content-center align-items-center noRequiest' >
                                    <div>You haven’t posted anything on this channel yet.</div>
                                </div>}

                            {/*code for DeclinedRequest   */}

                            <div>
                                <div className='d-flex justify-content-between ContainerDeclinedRequest p-2 mt-3'>
                                    <div className='d-flex  gap-2 '>
                                        <div className='d-flex align-items-center' >
                                            <img src='/Enggagement/ProifleCommunity.png' style={{ cursor: 'pointer' }} alt='' />
                                        </div>
                                        <div >

                                            <div className='d-flex align-items-center gap-3' >
                                                <div className='ComunityName '>Jasmine Watson</div>
                                                <div className='TopicCommunityBoxDetail '>Exhibition</div>

                                            </div>
                                            <div className='NameTime'>
                                                Reading Club | Today 04:30 pm
                                            </div>
                                        </div>

                                    </div>
                                    <div className='d-flex align-items-center gap-3'>
                                        <div className='DeclinedMsg'>Your post request was declined.</div>
                                        <div className='d-flex align-items-center pr-3' >
                                            <img src='/Enggagement/DustbinIcon.png' style={{ cursor: 'pointer' }} alt='' />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* for underReview   */}
                            {comunityGroup.requiestDeltail === 'UnderReview' &&
                                <div>
                                    <div>
                                        <div className='d-flex justify-content-between align-items-center mt-3'>
                                            <div className='d-flex  gap-2 '>
                                                <div className='d-flex align-items-center' >
                                                    <img src='/Enggagement/ProifleCommunity.png' style={{ cursor: 'pointer' }} alt='' />
                                                </div>
                                                <div >

                                                    <div className='d-flex align-items-center gap-3' >
                                                        <div className='ComunityName '>Jasmine Watson</div>
                                                        <div className='TopicCommunityBoxDetail '>Exhibition</div>

                                                    </div>
                                                    <div className='NameTime'>
                                                        Reading Club | Today 04:30 pm
                                                    </div>
                                                </div>

                                            </div>
                                            <div>
                                                <span className='UnderReview'>Under Review</span>
                                            </div>
                                        </div>
                                        <p className='mt-2'>
                                            <span className='captionText'>
                                                {trimmedText}
                                            </span>
                                            <span className='seeMoreText'>{seeMoreLink}</span>
                                        </p>

                                        <div className='sildeImgContainer'>
                                            <Carousel>
                                                <Carousel.Item>
                                                    <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                                                </Carousel.Item>
                                                <Carousel.Item>
                                                    <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                                                </Carousel.Item>
                                                <Carousel.Item>
                                                    <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                                                </Carousel.Item>
                                            </Carousel>
                                        </div>
                                    </div>
                                    <div className='d-flex gap-3 mt-4 justify-content-center'>
                                        <button className='EditBtnRequest' onClick={(e) => setComunityGroup({ ...comunityGroup, editPost: true })}>Edit</button>
                                        <button className='DeleteBtnRequest' onClick={(e) => setComunityGroup({ ...comunityGroup, deletePost: true })}>Delete</button>
                                    </div>
                                </div>}


                        </div>
                    }
                </div>

                {/* below right side details  */}
                <div className='col-md-6 d-flex justify-content-end mt-3'>
                    <div className='rightSideGroupDetails'>
                        <div className=' d-flex justify-content-between align-items-center'>
                            <div className='channelsHeadingRight'>Channels</div>
                            <div className='containerRightSideSearch d-flex align-items-center '>
                                <div>
                                    <img src='/Enggagement/SearchIconRightSide.png' className='pl-2' alt='' />
                                </div>
                                <input placeholder='Search Channels' className='rightSideSearch pl-2' />
                            </div>
                        </div>

                        <div className='channelContainerAll'>
                            <div className='d-flex gap-2 align-itmes-center mt-3 ' >
                                <div>
                                    <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                </div>
                                <div >
                                    <div className='ChannelNameComunity'>
                                        Xploresense Science Channel
                                    </div>
                                    <div className='NameTime'>
                                        Created by School   |   12,000+ Posts
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex gap-2 align-itmes-center mt-3' >
                                <div>
                                    <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                </div>
                                <div >
                                    <div className='ChannelNameComunity'>
                                        Xploresense Science Channel
                                    </div>
                                    <div className='NameTime'>
                                        Created by School   |   12,000+ Posts
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex gap-2 align-itmes-center mt-3' >
                                <div>
                                    <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                </div>
                                <div >
                                    <div className='ChannelNameComunity'>
                                        Xploresense Science Channel
                                    </div>
                                    <div className='NameTime'>
                                        Created by School   |   12,000+ Posts
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex gap-2 align-itmes-center mt-3' >
                                <div>
                                    <img src='/Enggagement/ProifleCommunity.png' alt='' />
                                </div>
                                <div >
                                    <div className='ChannelNameComunity'>
                                        Xploresense Science Channel
                                    </div>
                                    <div className='NameTime'>
                                        Created by School   |   12,000+ Posts
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {comunityGroup.deletePost && <DeletePostPopup handleDeletePostPopUpFalse={handleDeletePostPopUpFalse} />}
            {comunityGroup.editPost && <EditPostCommunity handleEditPostPopUpFalse={handleEditPostPopUpFalse} />}
        </div >
    )
}
